module.exports = __webpack_public_path__ + "img/allegro.26b18e5c.png";